import React from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import Games from "./pages/Games";
import Game from "./pages/Game";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Footer from "./components/Footer";
import "./assets/css/App.css"
import Soon from "./pages/Soon";
import Router from "./Router";
import GameDashboard from "./pages/GameDashboard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import {LEGACY_TO_NEW_GAME_SLUG} from "./utils/gameRoutes";

export default function App() {
    return (<>
        <Routes>
            <Route path="/" element={<Games/>}/>
            <Route path="/07abe05bdbd07eb5322d1b1cdf5a0df878" element={<GameDashboard/>}/>
            <Route path="/games" element={<Games/>}/>
            {Object.entries(LEGACY_TO_NEW_GAME_SLUG).map(([oldSlug, newSlug]) => (
                <Route
                    key={oldSlug}
                    path={`/games/${oldSlug}`}
                    element={<Navigate to={`/games/${newSlug}`} replace/>}
                />
            ))}
            <Route path="/games/:game_id" element={<Game/>}/>
            <Route path="/contact" element={<Contact/>}/>
            <Route path="/about" element={<About/>}/>
            <Route path="/soon" element={<Soon/>}/>
            <Route path="/:slug" element={<Router/>}/>
            <Route path="privacy-policy" element={<PrivacyPolicy/>}/>
            <Route path="/terms" element={<Terms/>}/>
        </Routes>
        <Footer/>
    </>);
}
